// Should this be somewhere more 'common'?
export enum AsyncProgressStatus {
    NotSubmitted,
    InProgress,
    Success,
    Failed,
}